import { format } from 'date-fns'

/**
 * Format a date string as "Apr 16, 11:27 AM" — standard display format
 * for created/updated timestamps throughout the app.
 */
export function formatDateTime(dateString: string): string {
  return format(new Date(dateString), 'MMM d, h:mm a')
}

/**
 * Format a date string as "Apr 16, 2026" — for compact displays
 * where time would be noise (e.g., tree nodes).
 */
export function formatDateOnly(dateString: string): string {
  return format(new Date(dateString), 'MMM d, yyyy')
}
